/**
 * Input component
 */

import React from 'react';
import { clsx } from 'clsx';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

export function Input({
  label,
  error,
  helperText,
  leftIcon,
  rightIcon,
  className,
  ...props
}: InputProps) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-theme-text mb-1">
          {label}
        </label>
      )}
      <div className="relative">
            {leftIcon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-theme-text-secondary">
            {leftIcon}
          </div>
        )}
        <input
          className={clsx(
            'block w-full rounded-lg border border-theme-border px-3 py-2',
            'bg-theme-paper text-theme-text placeholder-theme-text-disabled',
            'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent',
            error && 'border-error-main focus:ring-error-main',
            leftIcon && 'pl-10',
            rightIcon && 'pr-10',
            className
          )}
          {...props}
        />
        {rightIcon && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-auto z-10 text-theme-text-secondary">
            {rightIcon}
          </div>
        )}
      </div>
      {error && <p className="mt-1 text-sm text-error-main">{error}</p>}
      {helperText && !error && <p className="mt-1 text-sm text-theme-text-secondary">{helperText}</p>}
    </div>
  );
}


